module.exports = __webpack_public_path__ + "img/tatooine_700.63de9a43.gif";